// extracted by mini-css-extract-plugin
export var active = "PostColumn-module--active--7893a";
export var additionalLink = "PostColumn-module--additionalLink--852ec";
export var additionalLinks = "PostColumn-module--additionalLinks--4090c";
export var arrow = "PostColumn-module--arrow--3e1dc";
export var arrowNo = "PostColumn-module--arrow_no--b6a6a";
export var arrowYes = "PostColumn-module--arrow_yes--705e2";
export var cardsContainer = "PostColumn-module--cardsContainer--02bb7";
export var close = "PostColumn-module--close--f9d2f";
export var collectionCardImage = "PostColumn-module--collectionCardImage--43097";
export var collectionCardImageContainer = "PostColumn-module--collectionCardImageContainer--c398b";
export var collectionCardTitle = "PostColumn-module--collectionCardTitle--21a60";
export var copyOverlay = "PostColumn-module--copyOverlay--ce123";
export var download = "PostColumn-module--download--735fc";
export var flex = "PostColumn-module--flex--b685e";
export var flex1 = "PostColumn-module--flex_1--7f0b6";
export var flexCenter = "PostColumn-module--flex_center--8af08";
export var flexCenterCol = "PostColumn-module--flex_center_col--69cb8";
export var flexCol = "PostColumn-module--flex_col--d9315";
export var flexFixCenterCol = "PostColumn-module--flex_fix_center_col--737c4";
export var flexFixedCenterCol = "PostColumn-module--flex_fixed_center_col--ba81f";
export var linkButton = "PostColumn-module--linkButton--6a2b5";
export var moreButton = "PostColumn-module--moreButton--4b204";
export var moreIcon = "PostColumn-module--moreIcon--de423";
export var moreRow = "PostColumn-module--moreRow--c41bd";
export var offlineLibrary = "PostColumn-module--offlineLibrary--79d60";
export var overlayBottomRow = "PostColumn-module--overlayBottomRow--15c84";
export var overlayContainer = "PostColumn-module--overlayContainer--bebbc";
export var overlayContentType = "PostColumn-module--overlayContentType--2478e";
export var overlayTopRow = "PostColumn-module--overlayTopRow--92bf8";
export var postCardColumn = "PostColumn-module--postCardColumn--72570";
export var postCardLink = "PostColumn-module--postCardLink--0b32c";
export var postImage = "PostColumn-module--postImage--8cc9d";
export var postImageOverlay = "PostColumn-module--postImageOverlay--62542";
export var postTitle = "PostColumn-module--postTitle--0cf07";
export var postTitleRow = "PostColumn-module--postTitleRow--1f9f0";
export var profileImage = "PostColumn-module--profileImage--01d25";
export var publishingInformationLabel = "PostColumn-module--publishingInformationLabel--eef98";
export var removeButton = "PostColumn-module--removeButton--34dfc";
export var resourceInformation = "PostColumn-module--resourceInformation--e1075";
export var resourceInformationText = "PostColumn-module--resourceInformationText--6e56d";
export var rotating = "PostColumn-module--rotating--d42d3";
export var shareOverlay = "PostColumn-module--shareOverlay--283a8";
export var showMore = "PostColumn-module--showMore--cf728";
export var text = "PostColumn-module--text--a81c3";
export var titleRow = "PostColumn-module--titleRow--2cad0";
export var userNameWrapper = "PostColumn-module--userNameWrapper--e9a05";
export var viewAllCardLinks = "PostColumn-module--viewAllCardLinks--9de91";